import axios from "../axiosConfig";
import { currentLanguage } from "../../algorithms/storage";

//home
export const getSlider = () => {
  return axios.get(`Home/GetFocusDocumentLibraries`, {
    headers: {
      "Accept-Language": currentLanguage(),
    },
  });
};

//webinar
export const getaddWebinarForm = (communityId, token) => {
  return axios.get(`Webinar/GetWebinarForm/${communityId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addWebinar = (data, token) => {
  return axios.post(`Webinar/AddWebinar`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const searchWebinars = (
  communityID,
  pageNumber = 1,
  pageSize = 20,
  data = {},
  token
) => {
  return axios.post(
    `Webinar/Search/${communityID}/${pageNumber}/${pageSize}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getEditWebinarForm = (webinarID, communityID, token) => {
  return axios.get(`Webinar/GetEditWebinarForm/${webinarID}/${communityID}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateWebinar = (data, token) => {
  return axios.put("Webinar/UpdateWebinar", data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteWebinar = (webinarID, token) => {
  return axios.delete(`Webinar/DeleteWebinar/${webinarID}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getWebinar = (webinarId, token) => {
  return axios.get(`Webinar/Details/${webinarId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getUpcomingWebinars = () => {
  return axios.get(`Home/GetTopUpcomingWebinars`, {
    headers: {
      "Accept-Language": currentLanguage(),
    },
  });
};

export const getWebinars = () => {
  return axios.get(`Home/GetWebinarsList`, {
    headers: {
      "Accept-Language": currentLanguage(),
    },
  });
};

export const getPastWebinars = () => {
  return axios.get(`Home/GetPastWebinars`, {
    headers: {
      "Accept-Language": currentLanguage(),
    },
  });
};

export const getTopPastWebinars = () => {
  return axios.get(`Home/GetTopPastWebinars`, {
    headers: {
      "Accept-Language": currentLanguage(),
    },
  });
};

export const getWebinarbyId = (webinarId) => {
  return axios.get(`Home/GetWebinarById?webinarId=${webinarId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
    },
  });
};

export const searchNotifications = (
  pageNumber = 1,
  pageSize = 20,
  data = {},
  token
) => {
  return axios.post(`Notification/Search/${pageNumber}/${pageSize}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addNotificaton = (data, token) => {
  return axios.post(`Notification/AddNotification`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getNotificationForm = (token) => {
  return axios.get(`Notification/GetNotificationForm`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editNotificaton = (data, token) => {
  return axios.put(`Notification/UpdateNotification`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getEditNotificationForm = (notificationId, token) => {
  return axios.get(`Notification/GetEditNotificationForm/${notificationId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const delNotification = (notificationId, token) => {
  return axios.delete(`Notification/DeleteNotification/${notificationId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const resNotification = (notificationId, token) => {
  return axios.put(
    `Notification/ResendNotification/${parseInt(notificationId)}`,
    {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": currentLanguage(),
        // Authorization: `Bearer ${token}`,
      },
    }
  );
};
